<template>
  <v-alert type="warning"
           prominent
  >
    <v-row align="center">
      <v-col class="grow">
        Oops! The resource you're looking for cannot be found!
      </v-col>
      <v-col class="shrink"
      >
        <v-btn light
               :to="{ name: 'home' }"
        >
          Return to Home
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
export default {
  name: "NotFound"
}
</script>
